<section
  class="auth-prompt"
  data-testid="auth-prompt"
  [attr.aria-busy]="isPending()"
  aria-live="polite"
>
  <h2 class="auth-prompt__title" data-testid="auth-prompt-title" i18n="@@auth.prompt.title">
    Connexion requise
  </h2>
  <p class="auth-prompt__message" data-testid="auth-prompt-message" i18n="@@auth.prompt.message">
    Connectez-vous pour acceder a cet assistant.
  </p>

  @if (shouldPrompt() && failureReason() !== null) {
    @switch (failureReason()) {
      @case ("popup-blocked") {
        <p
          class="auth-prompt__error"
          data-testid="auth-prompt-error"
          role="alert"
          i18n="@@auth.prompt.error.popup-blocked"
        >
          La fenêtre de connexion a été bloquée par votre navigateur. Autorisez les fenêtres pop-up
          pour ce site puis réessayez.
        </p>
      }
      @case ("cancelled") {
        <p
          class="auth-prompt__error"
          data-testid="auth-prompt-error"
          role="alert"
          i18n="@@auth.prompt.error.cancelled"
        >
          La connexion a été annulée. Réessayez.
        </p>
      }
      @case ("timed-out") {
        <p
          class="auth-prompt__error"
          data-testid="auth-prompt-error"
          role="alert"
          i18n="@@auth.prompt.error.timed-out"
        >
          La connexion a pris trop de temps. Réessayez.
        </p>
      }
      @case ("invalid-origin") {
        <p
          class="auth-prompt__error"
          data-testid="auth-prompt-error"
          role="alert"
          i18n="@@auth.prompt.error.invalid-origin"
        >
          La connexion n'a pas pu être validée. Réessayez ou contactez le support si le problème
          persiste.
        </p>
      }
      @case ("verification-failed") {
        <p
          class="auth-prompt__error"
          data-testid="auth-prompt-error"
          role="alert"
          i18n="@@auth.prompt.error.verification-failed"
        >
          Votre session n'a pas pu être vérifiée. Réessayez.
        </p>
      }
      @default {
        <p
          class="auth-prompt__error"
          data-testid="auth-prompt-error"
          role="alert"
          i18n="@@auth.prompt.error.generic"
        >
          La connexion n'a pas abouti. Réessayez.
        </p>
      }
    }
  }

  @if (!attemptsExhausted()) {
    <button
      class="auth-prompt__action"
      data-testid="auth-prompt-action"
      type="button"
      formButton="primary"
      [disabled]="isPending()"
      [attr.aria-busy]="isPending()"
      (click)="authenticate()"
    >
      @if (isPending()) {
        <div
          class="d-flex align-items-center gap-3"
          data-testid="auth-prompt-pending"
          i18n="@@auth.prompt.pending"
        >
          <mat-spinner diameter="24">
            <span class="visually-hidden">Loading...</span>
          </mat-spinner>
          <span class="lh-1">Connexion en cours...</span>
        </div>
      } @else {
        <span data-testid="auth-prompt-retry" i18n="@@auth.prompt.action">Se connecter</span>
      }
    </button>
  } @else {
    <p
      class="auth-prompt__exhausted"
      data-testid="auth-prompt-exhausted"
      role="alert"
      i18n="@@auth.prompt.exhausted"
    >
      Trop de tentatives de connexion. Rechargez la page pour réessayer.
    </p>
  }
</section>
